export enum PROMOTION_TYPES {
  // badge
  FLASH_SALES = 'FLASH_SALES',
  APP_ONLY_PRICE = 'APP_ONLY_PRICE',
  MOBILE_ONLY_PRICE = 'MOBILE_ONLY_PRICE',
  TOP_SECRET_HOTELS = 'TOP_SECRET_HOTELS',
  MY_PRICE = 'MY_PRICE',
  PINK_PEOPLE = 'PINK_PEOPLE',
  BLACK_FRIDAY = 'blackFriday',
  CYBER_MONDAY = 'cyberMonday',
  TRAVEL_TUESDAY = 'travelTuesday',
  SUMMER_SALE = 'summerSale',
  AUTUMN_SALES = 'autumnSales',
  JANUARY_SALE = 'januarySale',
  PLUS = 'plus',
  VOUCHER_EXTRA = 'VOUCHER_EXTRA',
  VOUCHER = 'VOUCHER',
  PACKAGE_SAVINGS = 'PACKAGE_SAVINGS',

  // usp
  LONDON_EYE = 'LONDON_EYE',
  TRAVEL_EXTRA_PACK = 'TRAVEL_EXTRA_PACK',
  TOUR_DE_FRANCE = 'TOUR_DE_FRANCE',
  TRANSFER = 'transfer',
  TICKETS = 'tickets',
  SKIPASS = 'skiPass',
  SPA = 'spa',
  RESORT_CREDIT = 'resortCredit',
  BOOK_NOW_PAY_LATER = 'BOOK_NOW_PAY_LATER',
  DEPOSIT_AMOUNT = 'DEPOSIT_AMOUNT',

  // tour operator promotions
  TO = 'TOUR_OPERATOR',
  TO_LOGO = 'TOUR_OPERATOR_LOGO',
  TO_FR = 'TO_FR',
  TO_LASTMINUTE = 'TO_LASTMINUTE',
  TO_WEGDE = 'WEGDE',
  FLEXMIX = 'FLEXMIX',
  CASHBACK = 'CASHBACK',
  IMMEDIATE_DISCOUNT = 'IMMEDIATE_DISCOUNT',

  // Loyalty
  LOYALTY = 'LOYALTY',
}
